module.exports = __webpack_public_path__ + "img/background-document.2868ac19.svg";